
import ErrorModal from 'controls/error-modal.vue'
import PwaModal from 'components/pwa-modal.vue'
import $global from 'stores/global'
import {getCurrentUser} from '@aws-amplify/auth'
import {Hub} from '@aws-amplify/core'
import {Later} from 'utils/timers'
import {AuthError, signInWithRedirect} from 'aws-amplify/auth'
import {getCookie} from 'utils/utils'


export default {
  components: {
    ErrorModal,
    PwaModal,
  },
  data() {
    return {
      signed_in: false,
      inactivity_timer: new Later(1000 * 60 * 60),
      inactivity_events: ['mousemove', 'touchstart', 'touchmove', 'keydown', 'click', 'scroll'],
      reset_inactivity_timer: () => { 
        this.inactivity_timer.once(
          async () => {
            await $global.logout()
          }
        )
      }
    }
  },
  computed: {
    error () {
      return $global.error
    },
    loading () {
      return $global.loading
    }
  }, 
  watch: {
    signed_in: async function(signed_in) {
      if (signed_in) {
        await $global.start()
        this.startInactivityTimer()

        //
        // User came from a login page
        // 
        if (this.$route.path === '/login') {
          let redirect = localStorage.getItem('redirect')
          redirect = redirect ? JSON.parse(redirect) : {path: '/'}

          // If we come from newsletter give priority to it
          if (redirect.path == '/new-chat' && (redirect.query || {}).chat_query) {
            this.$router.push(redirect)
            return
          }

          if ($global.caps.adm_onboarding_enabled){
          // If we have incomplete onboarding execute it
            const onboarding = $global.onboarding 
            if (!onboarding || (!onboarding?.completed && $global.caps.su_remind_onboarding)) {
              $global.goToOnboarding()
              return
            }
          }
          // Exec redirect
          this.$router.push(redirect)
          return
        }

        //
        // User came via any other url and was already signed in
        // Just do nothing
        //
      }

      if (!signed_in) {
        this.destroyInactivityTimer() 
        window.location.reload()
      }
    }
  },
  async created () {
    if ($global.parent_page) {
      return
    }
    
    Hub.listen('auth', async data => {
      switch(data.payload.event) {
        case 'signedIn': this.signed_in = true; break
        case 'signedOut': this.signed_in = false; break
      }
    })
    
    try {
      await getCurrentUser()
      this.signed_in = true
    }
    catch(err) {
      if (err instanceof AuthError) {
        if (err.name === 'UserUnAuthenticatedException') {
          //
          // Bypass login page and go staright to IDP.
          // This is done to make login more convenient
          // on custom deployments like amdocs. We know
          // that users on custom deployments always use
          // 3rd-party idp, so there are no reasons to 
          // force them input email.
          //
          // Also we reserve the way for devteam to login
          // with cognito users (devteam cookie)
          //
          if (FORCE_IDP !== 'false' && !getCookie('devteam')) {
            await signInWithRedirect({provider: {custom: FORCE_IDP}})
          }

          const current_idp = sessionStorage.getItem('current_idp')
          if (FORCE_IDP === 'false' && current_idp) {
            await signInWithRedirect({provider: {custom: current_idp}})
          }
        }
      }
      // if there is no current user we simply ignore
      // router would detect this as well and redirect to login
    }
    finally {
      sessionStorage.removeItem('current_idp')
    }
  },
  methods: {
    startInactivityTimer() {
      this.inactivity_events.forEach(event => window.addEventListener(event, this.reset_inactivity_timer))
      this.reset_inactivity_timer()
    },
    destroyInactivityTimer() {
      this.inactivity_events.forEach(event => window.removeEventListener(event, this.reset_inactivity_timer))
      this.inactivity_timer.abort()
    },
  }
}
